import Pusher from 'pusher-js';

import { PUSHER_API_KEY } from '../env';


const pusher = new Pusher(PUSHER_API_KEY, {
  cluster: 'eu',
  encrypted: true,
});

export default pusher;
